<template>
  <div>
    <PageName
      :title="isEdit ? 'Редактировать подразделение' : 'Создать подразделение'"
      :buttons="
        isEdit
          ? [
              {
                text: 'Удалить',
                icon: 'delete',
                event: deleteDepartment,
                iconWidth: '12px',
              },
            ]
          : []
      "
    />
    <Preloader v-if="loading" />
    <Form
      v-if="!loading"
      @request="saveDepartment"
      class="create__department"
      v-model="depData"
    >
      <div class="create__department-form">
        <VInput
          name="name"
          required
          placeholder="Наименование"
        />

        <VSelect
          name="parent"
          item-text="name"
          placeholder="Родитель"
          :disabled="!isEdit"
          :items="
            isEdit
              ? departments.filter((dep) => dep.id !== depData.id)
              : departments
          "
          searchSelect
          department
        />

        <!-- possible props for heads: multiple, withCheckbox, selected-with-background -->
        <!--v-if="showHeadsSelected"-->
        <!--:items="leadersList"-->
        <VSelect
          placeholder="Добавить руководителя"
          name="heads"
          multiple
          withCheckbox
          :items="usersWithFIO"
          @change="selectleaders"
          searchSelect
          users
          :value="depData.heads"
        >
          <template slot="item" slot-scope="{ item }">
            <AccountBadge :user="item" />
          </template>
        </VSelect>
      </div>

      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          :text="isEdit ? 'Сохранить' : 'Создать'"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin-top: 12px"
        />
        <Button
          @click.native.prevent="XMLdialog = true"
          width="228px"
          height="48px"
          text="Загрузить с XML"
          class="btn-outline-primary"
          style="margin-top: 32px"
        />
      </div>
    </Form>

    <XMLModal
      v-if="XMLdialog"
      @close="XMLdialog = false"
      url="departments/import"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import XMLModal from "@/components/Modals/XMLModal.vue";
import Preloader from "@/components/Preloader";
import {
  createDepartment,
  updateDepartment,
  deleteDepartment,
  getDepartmentById,
} from "@/api/departments";
import { concatArrayInArrayWithUniqueItems } from "@/utils/utils";
// import { updateUser } from "@/api/users.js";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "SaveDepartments",
  components: {
    Form,
    VInput,
    VSelect,
    Button,
    PageName,
    AccountBadge,
    XMLModal,
    Preloader
  },
  props: {
    action: String
  },
  data() {
    return {
      saveLoading: false,
      XMLdialog: false,
      depData: {
        heads: [],
      },
      loading: false,
      parent: {},
      leaders: [],
      leadersList: [],
      showHeadsSelected: false,
      id: null
    };
  },

  async mounted() {
    this.id = parseInt(this.$route.params.id_department);
    const department = this.$route.params.node;

    if (this.isCreate) {
      if (department) {
        this.loading = true
        this.depData = {
          parent: {
            name: department.name,
            id: department.id
          }
        }
        this.loading = false
      }
    } else if (this.isEdit) {
      this.loading = true

      // if(department.heads.length) {
      //   department.heads.map((head) => {
      //     this.leaders.push(head)
      //   });
      // }

      if (this.id) {
        const { data } = await getDepartmentById(this.id)
        this.depData = {
          ...data
        }
      }
      const users = this.$store.getters['users/getUsers']
      if (this.depData.heads) {
        const data = concatArrayInArrayWithUniqueItems(this.depData.heads, users, 'id')
        this.$store.commit('users/SET_USERS', data)

        // this.leadersList = this.usersWithFIO.filter(leader => leader.department_id === parentId);
        this.showHeadsSelected = !!this.leadersList.length;
      }
      this.loading = false
    }
  },

  computed: {
    ...mapState("departments", ["departments", "saveDepartmentsLoading"]),
    ...mapGetters("departments", ["getParentDepartmentById"]),
    ...mapGetters("users", ["usersWithFIO"]),
    isEdit() {
      return this.action === 'update'
    },
    isCreate() {
      return this.action === 'create'
    },
    getParent() {
      return this.parent
    },
  },
  methods: {
    ...mapMutations("departments", [
      "ADD_DEPARTMENTS",
      "DELETE_DEPARTMENTS",
      "UPDATE_DEPARTMENT",
    ]),
    ...mapActions("departments", ["getTreeDepartments"]),
    ...mapActions("users", ["getUsers"]),
    saveDepartment: async function (data) {
      this.saveLoading = true;
      const userIds = this.depData.heads?.map((user) => user?.id);

      try {
        if (this.isEdit) {
          const response = await updateDepartment(
              data.name,
              data.parent?.id,
              userIds,
              data.id
          );

          this.UPDATE_DEPARTMENT(response.data);
        } else {
          const response = await createDepartment(
              data.name,
              data.parent?.id,
              userIds
          );

          data.id = response.data.id;
          this.ADD_DEPARTMENTS(response.data);
        }
      } catch (err) {
        Promise.reject(err);
      }

      // const deletedHeads = this.leaders?.filter((leader) => !heads.some((head) => leader.id === head.id))
      // for (let index = 0; index < deletedHeads.length; index++) {
      //   const rolesId = deletedHeads[index].roles?.map((role) => role.id).filter((id) => id !== 3)
      //   rolesId.push(2)
      //   await updateUser(
      //       deletedHeads[index].id,
      //       deletedHeads[index].name,
      //       deletedHeads[index].surname,
      //       deletedHeads[index].patronymic,
      //       data.id,
      //       deletedHeads[index].email,
      //       deletedHeads[index].birthday,
      //       deletedHeads[index].phone,
      //       rolesId,
      //       false,
      //       deletedHeads[index].filiation?.id
      //   );
      // }

      // for (let index = 0; index < heads.length; index++) {
      //   const rolesId = heads[index].roles?.map((role) => role.id) || []
      //   if (!rolesId.length) rolesId.push(2)
      //   rolesId.push(3)
      //   await updateUser(
      //       heads[index].id,
      //       heads[index].name,
      //       heads[index].surname,
      //       heads[index].patronymic,
      //       data.id,
      //       heads[index].email,
      //       heads[index].birthday,
      //       heads[index].phone,
      //       rolesId,
      //       true,
      //       heads[index].filiation?.id
      //   );
      // }

      this.getThreeDepartments();
      // this.getUsers()
      this.saveLoading = false;
    },
    getThreeDepartments() {
      this.getTreeDepartments().then(() => {
        this.$router.push({ name: "Departments" });
      });
    },
    selectleaders(data) {
      this.depData.heads = []
      data?.map((leader) => {
        this.depData.heads.push(leader)
      })
    },
    deleteDepartment() {
      const deleteDepFunc = () =>
        deleteDepartment(this.depData.id).then(() => {
          this.getThreeDepartments();
          this.DELETE_DEPARTMENTS(this.depData.id);
          this.$router.push("/admin-panel");
        });

      this.$root.confrim(
        "Вы точно хотите удалить это подразделение?",
        deleteDepFunc,
        "Да"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.create__department {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  @media screen and (max-width:1500px){
    margin-top: 24px;
  }

  .create__department-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;

    @media screen and (max-width:1500px){
      padding: 32px 30px;
      column-gap: 18px;
      row-gap: 8px;
    }
  }
}
</style>
